import { initiateLiveChat, makeTrackLiveChat, initiateEnhancedChat } from '../../../helpers/chat/live-chat.helper';
import { useFeature } from '../../features/features.hooks';
import { useTrackEvent } from '../analytics.hooks';

export const useLiveChat = () => {
	const isEnhancedLiveChatEnabled = useFeature<boolean>('enhanced-external-chat', { isSiteWide: true });
	const trackEvent = useTrackEvent();
	const trackChat = makeTrackLiveChat(trackEvent);
	if (isEnhancedLiveChatEnabled) {
		return () => initiateEnhancedChat(trackChat);
	} else {
		return () => initiateLiveChat(trackChat);
	}
};
